import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/invite")({
  beforeLoad: async ({ context, location }) => {
    if (location.pathname === "/invite/accept") {
      return;
    }
    // Allow authenticated users to access group invitations
    if (location.pathname.startsWith("/invite/group/")) {
      return;
    }
    // For company invitations, redirect logged-in users to app
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
  },
  component: InviteLayout,
});

function InviteLayout() {
  return <Outlet />;
}
